import { createAction } from '@reduxjs/toolkit';

import type {
  DadosProcesso,
  DadosProtocolo,
  Documento,
  Parte,
} from '@/types/peticionamento/domainTypes';

export { criarPartesBatch, finalizarPeticionamento } from './services';
export const setPeticionamentoErro = createAction<string | null>('peticionamento/setErro');
export const setEtapaAtual = createAction<number>('peticionamento/setEtapaAtual');
export const atualizarDadosProcesso = createAction<Partial<DadosProcesso>>(
  'peticionamento/atualizarDadosProcesso',
);
export const adicionarParte = createAction<Parte>('peticionamento/adicionarParte');
export const atualizarParte = createAction<{ id: string; dados: Partial<Parte> }>(
  'peticionamento/atualizarParte',
);
export const removerParte = createAction<{ id: string }>('peticionamento/removerParte');
export const adicionarDocumento = createAction<Documento>('peticionamento/adicionarDocumento');
export const removerDocumento = createAction<{ id: string }>('peticionamento/removerDocumento');
export const atualizarAceiteTermos = createAction<boolean>('peticionamento/atualizarAceiteTermos');
export const atualizarTipoAssinatura = createAction<'digital' | 'eletronica' | 'fisica'>(
  'peticionamento/atualizarTipoAssinatura',
);
export const limparPeticionamento = createAction('peticionamento/limpar');

export const setPartes = createAction<Parte[]>('peticionamento/setPartes');
export const setDocumentos = createAction<Documento[]>('peticionamento/setDocumentos');
export const setDadosPeticionamento = createAction<Partial<DadosProtocolo>>(
  'peticionamento/setDadosProtocolo',
);

export const atualizarDadosPeticionamento = createAction<Partial<DadosProtocolo>>(
  'peticionamento/atualizarDadosProtocolo',
);

export const atualizarDadosTribunal = createAction<Record<string, unknown>>(
  'peticionamento/atualizarDadosTribunal',
);

export const setErroGeral = setPeticionamentoErro;
export const atualizarPartes = setPartes;
export const atualizarDocumentos = setDocumentos;
